"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _ProfileIntegrationsActionsList = _interopRequireDefault(require("crm_ui/profile/sidebar/integrations/actions/ProfileIntegrationsActionsList"));

var _sidebarIntegrationPropertyTypes = _interopRequireDefault(require("crm_ui/constants/sidebarIntegrationPropertyTypes"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var NUM_PROPERTIES_TO_DISPLAY = 3;

var _default = (0, _createReactClass.default)({
  displayName: 'ProfileIntegrationLinkedSalesObjectItem',
  propTypes: {
    applicationId: _propTypes.default.number.isRequired,
    appName: _propTypes.default.string.isRequired,
    associatedObjectId: _propTypes.default.number.isRequired,
    associatedObjectType: _propTypes.default.oneOf([_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL]).isRequired,
    closeIframeModal: _propTypes.default.func.isRequired,
    item: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    objectTypeId: _propTypes.default.number.isRequired,
    openIframeModal: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      cardIsExpanded: false
    };
  },
  toggleCardExpansion: function toggleCardExpansion() {
    return this.setState({
      cardIsExpanded: !this.state.cardIsExpanded
    });
  },
  renderHeader: function renderHeader() {
    return _react.default.createElement("div", {
      className: "m-bottom-1",
      "data-selenium-test-bizops": "SalesIntegrationCard--header"
    }, this.renderTitle());
  },
  renderTitle: function renderTitle() {
    var item = this.props.item;
    var link = item.get('link');
    var title = item.get('title');

    if (!link) {
      return _react.default.createElement("span", {
        className: "is--text--bold"
      }, title);
    }

    return _react.default.createElement(_UILink.default, {
      href: link,
      className: "is--text--bold",
      external: true
    }, title);
  },
  renderProperties: function renderProperties() {
    var _this = this;

    var propertiesToDisplay;
    var allProperties = this.props.item.get('properties');

    if (allProperties.size <= NUM_PROPERTIES_TO_DISPLAY || this.state.cardIsExpanded) {
      propertiesToDisplay = allProperties;
    } else {
      propertiesToDisplay = allProperties.slice(0, NUM_PROPERTIES_TO_DISPLAY);
    }

    return propertiesToDisplay.map(function (property) {
      return _this.renderProperty(property);
    });
  },
  renderProperty: function renderProperty(property) {
    var label = property.get('label');
    return _react.default.createElement("div", {
      key: label,
      "data-selenium-test-bizops": "SalesIntegrationCard--property-" + label
    }, _react.default.createElement("strong", {
      className: "m-right-1"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "profileSidebarModule.integrations.propertyLabel",
      options: {
        label: label
      },
      useGap: true
    })), _react.default.createElement("span", {
      "data-selenium-test-bizops": "SalesIntegrationCard--propertyValue-" + label
    }, this.renderPropertyValue(property)));
  },
  renderPropertyValue: function renderPropertyValue(property) {
    var alertSeverity = property.getIn(['alert', 'severity']);

    if (alertSeverity === 'ERROR') {
      return this.renderErroredValue();
    }

    switch (property.get('dataType')) {
      case _sidebarIntegrationPropertyTypes.default.CURRENCY:
        return this.renderCurrencyValue(property);

      case _sidebarIntegrationPropertyTypes.default.DATETIME:
        return this.renderDateTimeValue(property);

      case _sidebarIntegrationPropertyTypes.default.DATE:
        return this.renderDateValue(property);

      case _sidebarIntegrationPropertyTypes.default.LINK:
        return this.renderLinkValue(property);

      case _sidebarIntegrationPropertyTypes.default.EMAIL:
        return this.renderEmailValue(property);

      case _sidebarIntegrationPropertyTypes.default.NUMERIC:
        return this.renderNumericValue(property);

      case _sidebarIntegrationPropertyTypes.default.STRING:
        return this.renderPlainTextValue(property);

      case _sidebarIntegrationPropertyTypes.default.STATUS:
        return this.renderStatusValue(property);

      default:
        return null;
    }
  },
  renderErroredValue: function renderErroredValue() {
    return _react.default.createElement(_Small.default, {
      use: "help"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "profileSidebarModule.integrations.propertyError"
    }));
  },
  renderCurrencyValue: function renderCurrencyValue(property) {
    var value = property.get('value');
    var currencyCode = property.get('currency');
    return _I18n.default.formatCurrency(value, {
      currencyCode: currencyCode
    });
  },
  renderDateTimeValue: function renderDateTimeValue(property) {
    var value = property.get('value');
    return _I18n.default.moment.utc(value).portalTz().format('LLLL');
  },
  renderDateValue: function renderDateValue(property) {
    var value = property.get('value');
    return _I18n.default.moment(value.join('-'), 'YYYY-MM-DD').format('LL');
  },
  renderLinkValue: function renderLinkValue(property) {
    var value = property.get('value');
    var linkLabel = property.get('linkLabel');
    return _react.default.createElement(_UILink.default, {
      href: value,
      external: true
    }, linkLabel);
  },
  renderEmailValue: function renderEmailValue(property) {
    var value = property.get('value');
    return _react.default.createElement(_UILink.default, {
      href: "mailto:" + value
    }, value);
  },
  renderNumericValue: function renderNumericValue(property) {
    var value = property.get('value');
    return _I18n.default.formatNumber(value);
  },
  renderPlainTextValue: function renderPlainTextValue(property) {
    return property.get('value');
  },
  renderStatusValue: function renderStatusValue(property) {
    var value = property.get('value');
    var type = property.get('optionType').toLowerCase();
    return _react.default.createElement(_UITag.default, {
      use: type,
      inline: true
    }, value);
  },
  renderViewMoreToggle: function renderViewMoreToggle() {
    var properties = this.props.item.get('properties');

    if (properties.size <= NUM_PROPERTIES_TO_DISPLAY) {
      return null;
    }

    var buttonTextKey = "profileSidebarModule.integrations.linkedSalesObjectView" + (this.state.cardIsExpanded ? 'Less' : 'More');
    return _react.default.createElement(_UIButton.default, {
      className: "m-all-0",
      use: "link",
      onClick: this.toggleCardExpansion
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: buttonTextKey
    }));
  },
  renderActionsDropdown: function renderActionsDropdown() {
    var _this$props = this.props,
        applicationId = _this$props.applicationId,
        appName = _this$props.appName,
        associatedObjectType = _this$props.associatedObjectType,
        associatedObjectId = _this$props.associatedObjectId,
        closeIframeModal = _this$props.closeIframeModal,
        item = _this$props.item,
        objectTypeId = _this$props.objectTypeId,
        openIframeModal = _this$props.openIframeModal;
    var actions = item.get('actions');

    if (!(actions.size > 0)) {
      return null;
    }

    var objectId = item.get('objectId');
    var iframeParentTitle = item.get('title');
    return _react.default.createElement(_ProfileIntegrationsActionsList.default, {
      actions: actions,
      applicationId: applicationId,
      appName: appName,
      associatedObjectId: associatedObjectId,
      associatedObjectType: associatedObjectType,
      closeIframeModal: closeIframeModal,
      buttonClassName: "m-all-0",
      buttonText: _I18n.default.text('profileSidebarModule.integrations.actions'),
      buttonUse: "link",
      dropdownButtonUse: "link",
      iframeParentTitle: iframeParentTitle,
      objectId: objectId,
      objectTypeId: objectTypeId,
      openIframeModal: openIframeModal
    });
  },
  renderFooter: function renderFooter() {
    var item = this.props.item;

    if (!(item.get('actions').size > 0) && !(item.get('properties').size > NUM_PROPERTIES_TO_DISPLAY)) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "m-top-3 integrations-card-actions",
      "data-selenium-test-bizops": "SalesIntegrationCard--footer"
    }, this.renderActionsDropdown(), this.renderViewMoreToggle());
  },
  render: function render() {
    return _react.default.createElement(_UITile.default, {
      className: "m-bottom-5 p-y-3 p-x-4",
      "data-selenium-test-bizops": "SalesIntegrationCard"
    }, this.renderHeader(), this.renderProperties(), this.renderFooter());
  }
});

exports.default = _default;
module.exports = exports.default;